// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_Jupiter_Headfont__HUk-s{
    font-weight: 900 !important;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Jupiter/DashboardMain_Jupiter/Header_Jupiter.module.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B","sourcesContent":[".Headfont{\n    font-weight: 900 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Headfont": `Header_Jupiter_Headfont__HUk-s`
};
export default ___CSS_LOADER_EXPORT___;
